import { useMutation } from 'react-query'
import useCacheKeys from '../../../hooks/use-cache-keys'
import useCache from '../../../hooks/use-cache'
import useApi from '../../../hooks/use-api'
import { get } from 'lodash'
import useToasts from '../../../hooks/use-toasts'

const useCourseEnroll = ({
    courseId,
    onSuccess = () => {},
}) => {
    const cacheKeys = useCacheKeys()
    const { clearCache } = useCache({ key: [cacheKeys.COURSES, courseId], onReload: onSuccess})
    const { api, url, endpoints } = useApi()
    const { toastSuccess } = useToasts({ successMessage: 'Student Enrolled!', onSuccess: clearCache })
    const { toastError } = useToasts()
    const [ enroll, {isLoading} ] = useMutation(
        ({id, isRequired}) => {
            console.log({ userId: id, isRequired })
            return api.post(url(endpoints.userCourseEnrollment, { userId: id, courseId }), { isRequired })
        },
        {
            onSuccess: toastSuccess,
            onError: (response) => {
                switch (get(response, 'status')) {
                case 403:
                    toastError(get(response, 'data', 'UNKNOWN 403'))
                    //onError(get(response, 'data', 'UNKNOWN 403'))
                    break
                default:
                    toastError(`UNKNOWN ${get(response, 'status')}`)
                        //onError(`UNKNOWN ${get(response, 'status')}`)
                }
            }
        }
    )

    return {
        isLoading,
        enroll
    }
}

export default useCourseEnroll